(function () {
  function initComparison(section) {
    if (!section || section.dataset.acReady === 'true') return;

    var track = section.querySelector('[data-ac-track]');
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-ac-slide]'));
    var prev = section.querySelector('[data-ac-prev]');
    var next = section.querySelector('[data-ac-next]');
    var dotsWrap = section.querySelector('[data-ac-dots]');

    if (!track || !slides.length) return;

    section.dataset.acReady = 'true';

    var dots = [];
    var activeIndex = 0;

    function slideLeft(slide) {
      return slide.offsetLeft - track.offsetLeft;
    }

    function nearestIndex() {
      var left = track.scrollLeft;
      var closest = 0;
      var distance = Infinity;

      slides.forEach(function (slide, index) {
        var delta = Math.abs(slideLeft(slide) - left);
        if (delta < distance) {
          distance = delta;
          closest = index;
        }
      });

      return closest;
    }

    function updateControls(index) {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));

      if (prev) prev.disabled = activeIndex === 0;
      if (next) next.disabled = activeIndex === slides.length - 1;

      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === activeIndex);
        dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false');
      });
    }

    function goTo(index) {
      var target = Math.max(0, Math.min(index, slides.length - 1));
      track.scrollTo({ left: slideLeft(slides[target]), behavior: 'smooth' });
      updateControls(target);
    }

    if (dotsWrap) {
      slides.forEach(function (_, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Go to comparison ' + (index + 1));
        dot.addEventListener('click', function () { goTo(index); });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    if (prev) prev.addEventListener('click', function () { goTo(activeIndex - 1); });
    if (next) next.addEventListener('click', function () { goTo(activeIndex + 1); });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateControls(nearestIndex());
        ticking = false;
      });
    }, { passive: true });

    window.addEventListener('resize', function () {
      updateControls(nearestIndex());
    });

    updateControls(0);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-auraa-comparison]').forEach(initComparison);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();